<template>
  <div class="recommended">
    <search-layout>
      <div class="item">
        <label>视频名称：</label>
        <div class="input">
          <a-input
            placeholder="请输入歌曲名称"
            size="large"
            v-model:value="params.title"
          />
        </div>
      </div>
     
      <div class="item">
        <label>是否上架：</label>
        <a-select size="large" v-model:value="params.status">
          <a-select-option value="">全部</a-select-option>
          <a-select-option value="1">上架</a-select-option>
          <a-select-option value="2">下架</a-select-option>
        </a-select>
      </div>
      <!-- <div class="item">
        <label>推荐日期：</label>
        <a-date-picker size="large" @change="change" format="YYYY/MM/DD" />
      </div> -->
      <template #button>
        <a-button type="primary" size="large" @click="search">搜索</a-button>
      </template>
    </search-layout>
    <table-layout>
      <a-table
        :dataSource="list"
        :columns="columns"
        rowKey="id"
        :scroll="{ y: true }"
         :pagination="pagination"
        @change="handleTableChange"
      >
        <template #createdAt="{record}">
          {{ record.createdAt }}
        </template>
          <template #status="{record}">
          {{ record.status == 2 ? "否" : "是" }}
        </template>
        <template #recommend="{ record }">
          {{ record.recommend == 2 ? "否" : "是" }}
        </template>
        <template #action="{ record }">
          <a-button type="primary" size="small" @click="open(record, 'sort')"
            >编辑</a-button
          >
          <a-button
            class="mar"
            type="primary"
            size="small"
            @click="modify(record, 'recommend')"
            >{{ record.recommend == 2 ? "推荐" : "取消推荐" }}</a-button
          >
        </template>
      </a-table>
    </table-layout>

    <a-modal
      v-model:visible="visible"
      title="修改排序"
      @ok="handleOk"
      okText="保存"
    >
      <a-form
        :model="form"
        :rules="rules"
        ref="formRef"
        :wrapperCol="{ span: 14 }"
        :labelCol="{ span: 6 }"
      >
        <a-form-item label="排序" name="sort">
          <a-input v-model:value="form.sort" />
        </a-form-item>
      </a-form>
    </a-modal>
  </div>
</template>

<script>
import { reactive, toRefs, onMounted, ref } from "vue";
import searchLayout from "@/layout/search";
import tableLayout from "@/layout/table";
import columns from "./columns";
import { getList, update } from "@/api/video";

import { message } from "ant-design-vue";
export default {
  components: {
    searchLayout,
    tableLayout,
  },
  setup() {
    const formRef = ref();
    const state = reactive({
      status: "",
      list: [],
      date: "",
      visible: false,
      form: {
        sort: "",
      },
      pagination: {
        total: 0,
      },
      params: {
        limit: 10,
        offset: 0,
        status: "",
        uid: "",
        title: "",
      },
    });
 
    const modify = ({ id }, type) => {
      let pramas =
        type == "recommend" ? { recommend: 2 } : { sort: state.form.sort };
      update(id, pramas).then((res) => {
        message.success(type == "recommend" ? "取消推荐" : "修改成功");
        state.visible = type == "recommend" ? state.visible : false;
        init();
      });
    };
    const init = () => {
      getList({
        ...state.params,
        recommend: 1,
        type:'sort'
      }).then((res) => {
        state.list = res.rows;
         state.pagination.total = res.count;
      });
    };
     const handleTableChange = ({ current }) => {
      state.params.offset = (current - 1) * state.params.limit;
      init();
    };
    const search = () => {
      state.params.offset = 0;
      init();
    };
    const change = (value, dateString) => {
      state.params.updatedAt = dateString;
    };
    const rules = {
      sort: [{ required: true, message: "请输入排序", trigger: "blur" }],
    };
    let types;
    let records;
    const open = (record, type) => {
      types = type;
      records = record;
      formRef.value && formRef.value.resetFields();
      state.form.sort = record.sort;
      state.visible = true;
    };
    const handleOk = () => {
      formRef.value.validate().then((res) => {
        modify(records, types);
      });
    };

    onMounted(() => {
      init();
    });
    return {
      ...toRefs(state),
      columns,
      modify,
  
      change,
      search,
      handleOk,
      rules,
      formRef,
      open,
      handleTableChange
    };
  },
};
</script>

<style lang="less">
.recommended {
  height: 100%;
  overflow: hidden;
  .mar {
    margin: 0 10px;
  }
}
</style>
